<div class="flex items-center gap-lg">
  <img class="size-12" aria-hidden="true" [src]="imgSrc()" />
  <div class="flex flex-col gap-xs">
    <span class="text-2xl font-semibold text-default">
      {{ title() }}
      <span class="text-base">
        @switch (pricingModel()) {
          @case ('per_unit') {
            {{ '/employee/month' | translate }}
          }
          @default {
            {{ '/month' | translate }}
          }
        }
      </span>
    </span>
    @if (caption()) {
      <span class="text-sm font-medium text-support">{{ caption() }}</span>
    }
    <span class="text-base font-medium text-support">{{ description() }}</span>
  </div>
</div>

<ng-content></ng-content>
